import { Injectable, TemplateRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastsService {
  toasts: any[] = [];

  success(textOrTpl: string | TemplateRef<any>) {
    this.show(textOrTpl, { classname: 'border-success d-flex mb-4', iconname: 'check_circle', iconcolor: 'text-white', state: 'Success'});
  }

  warn(textOrTpl: string | TemplateRef<any>) {
    this.show(textOrTpl, { classname: 'border-warning d-flex mb-4', iconname: 'error', iconcolor: 'text-body', state: 'Warning'});
  }

  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  remove(toast:any) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  clear() {
    this.toasts.splice(0, this.toasts.length);
  }
}
